// extracted by mini-css-extract-plugin
module.exports = {"container":"userTableHeader_container__2h3ju","wrapper":"userTableHeader_wrapper__1iCS_","header":"userTableHeader_header__3U4JB"};